export enum ATTACHMENTS_TABS {
  FILE = "0",
  ARCHIVED = "1",
}
export interface SnackbarMessage {
  color: "success" | "error";
  text: string;
  visible: boolean;
}
